export const GET_ACTIVITIES = 'GET_ACTIVITIES'
